import { ChangeDetectionStrategy, Component } from '@angular/core';
import { PillType } from '../../shared/components/pill/pill.model';

@Component({
  selector: 'app-pill-demo',
  templateUrl: './pill-demo.component.html',
  styleUrls: ['./pill-demo.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PillDemoComponent {
  readonly pillType = PillType;
}
